import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  sellerName: {
    id: 'product_jp_customization_result_seller',
    defaultMessage: 'This seller name',
  },
} as Record<string, I18nDefinition>
